import LoadImage from "blueimp-load-image";

const AVAILABLE_FILE_TYPE = [
  /** 허용한 타입 */
  "image/jpeg",
  "image/png",
  "image/bmp",
  "image/webp",
  "image/avif"
];
const WRONG_FILE_TYPE = [
  /** 차단한 타입 */
  "image/gif"
];
const NULL_EXTENSION = [
  /** 데스크탑 사파리에서 직접 확인해야 하는 허용된 확장자들 */
  "webp"
];

const _makeImageElement = src => {
  const returnImg = new Image();
  returnImg.src = src;
  return new Promise((resolve, reject) => {
    returnImg.onload = () => resolve(returnImg);
  });
};

const ImageLoader = (() => {
  return {
    getImageElement: event => {
      if (!event.target.files || event.target.files.length === 0)
        return { err: "nullImg" };

      const fileType = event.target.files[0].type;
      const fileName = event.target.files[0].name;
      const fileExt = fileName.split(".")[1];
      const isAvailableExtension = AVAILABLE_FILE_TYPE.some(
        val => fileType === val
      );
      const isForbiddenExtension = WRONG_FILE_TYPE.some(
        val => fileType === val
      );
      /**
       * isSafeExtension: 데스크탑 사파리에서 "image/webp" 요청하면 fileType = ""이
       * 되어 상단 변수만으로는 판별이 안되기에 추가한 코드
       * */
      const isSafeExtension = NULL_EXTENSION.some(val => fileExt === val);

      if (!isAvailableExtension && !isSafeExtension) {
        return {
          err: "typeError",
          errObj: isForbiddenExtension
            ? null
            : new Error(`img type -> "${fileType}", ext -> "${fileExt}"`)
        };
      }

      return new Promise((resolve, reject) => {
        LoadImage(
          event.target.files[0],
          async function (canvas) {
            try {
              const dataUrl = canvas.toDataURL("image/jpeg", 1);
              const returnElement = await _makeImageElement(dataUrl);
              resolve({ imgElem: returnElement, dataUrl });
            } catch (error) {
              if (error.message.includes("toDataURL")) {
                /**
                 * 데스크탑 사파리에서 "image/webp" 등의 경우 toDataURL 함수를
                 * 지원하지 않기에 에러가 발생된다
                 * */
                resolve({ err: "typeError", errObj: null });
              } else {
                resolve({ err: "unknown", errObj: error });
              }
            }
          },
          { orientation: true, canvas: true }
        );
      });
    }
  };
})();

export default ImageLoader;
